import { EventEmitter } from 'eventemitter3';
const createUserUserDetailsScopesStore = () => {
    let userUserDetailsScopes = { userDetailsDataScopes: undefined };
    const eventEmitter = new EventEmitter();
    return {
        getSnapshot: () => userUserDetailsScopes,
        subscribe: (callback) => {
            eventEmitter.addListener('update', callback);
            return () => {
                eventEmitter.removeListener('update', callback);
            };
        },
        setUserDetailsScopes: (userDetailsDataScopes) => {
            userUserDetailsScopes = { ...userUserDetailsScopes, userDetailsDataScopes };
            eventEmitter.emit('update');
        },
    };
};
export const userUserDetailsScopesStore = createUserUserDetailsScopesStore();
export const setUserDetailsScopes = (userDetailsScopes) => {
    userUserDetailsScopesStore.setUserDetailsScopes(userDetailsScopes);
};
